import { c as _c } from "react/compiler-runtime";
import { ListItem, ListItemAvatar, ListItemContent, ListItemDescription, ListItemSide, ListItemTitle } from "@opensea/ui-kit";
import { useCallback } from "react";
import { useButton } from "../../../../../components/Button/useButton";
function ProfileCollectionListItem(t0) {
  const $ = _c(8);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  const {
    renderLink: Link,
    onClick
  } = useButton(props);
  let t1;
  if ($[2] !== Link) {
    t1 = props_0 => <Link {...props_0} />;
    $[2] = Link;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const renderLink = t1;
  let t2;
  if ($[4] !== onClick || $[5] !== props || $[6] !== renderLink) {
    t2 = <ListItem renderLink={renderLink} {...props} onClick={onClick} />;
    $[4] = onClick;
    $[5] = props;
    $[6] = renderLink;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
export { ProfileCollectionListItem, ListItemAvatar as ProfileCollectionListItemAvatar, ListItemContent as ProfileCollectionListItemContent, ListItemDescription as ProfileCollectionListItemDescription, ListItemSide as ProfileCollectionListItemSide, ListItemTitle as ProfileCollectionListItemTitle };